<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('subtitle')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('subtitle')" v-model.lazy="subtitle">
        </div>
      </div>
      <table-edit :cols="columnDefinitions" :rows="records"></table-edit>
    </window-tab>
    <window-tab title="Data" icon="database">
      <album-select-group v-model="sponsorsAlbumId"></album-select-group>
      <album-select-group v-model="logosAlbumId" label="Logos"></album-select-group>
      <picture-select-group v-model="topLeftImageId" :album-id="logosAlbumId"
                            label="Top left image"></picture-select-group>
      <picture-select-group v-model="topRightImageId" :album-id="logosAlbumId"
                            label="Top right image"></picture-select-group>
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row" v-for="(v, k) in columnDefinitions" :key="k">
        <label :for="safeId(k)" class="col-sm-4 col-form-label">{{ v }}</label>
        <div class="col-sm-8">
          <column-select :id="safeId(k)" :value="columnMap[k]" @input="val => {
            columnMap[k] = val
            columnMap = columnMap
          }" :dataset-id="datasetId"></column-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <number-input-group v-model="pageIntervalSecs" label="Page interval (s)"/>
        <number-input-group v-model="itemsPerPage" label="Items per page"/>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapImageIdToImage, mapOverlayData, mapOverlayOptions, mapTemplateData } from '@/utils'
  import * as action from '@/store/action-types'

  export default {
    name: 'starting-list',
    mixins: [templateMixin],
    data () {
      return {
        columnDefinitions: {
          'track': 'Track',
          'bibNumber': 'Bib number',
          'lastName': 'Last name',
          'firstName': 'First name',
          'country': 'Country',
          'club': 'Club'
        }
      }
    },
    computed: {
      ...mapOverlayData(['title', 'subtitle']),
      ...mapOverlayData({'records': {default: []}}),
      ...mapOverlayData(['topLeftImage', 'topRightImage']),
      ...mapOverlayOptions({pageIntervalSecs: {default: 0}, itemsPerPage: {default: 8}}),
      ...mapTemplateData(['sponsorsAlbumId', 'datasetId']),
      ...mapTemplateData(['logosAlbumId', 'topLeftImageId', 'topRightImageId']),
      ...mapTemplateData({columnMap: {default: {}}}),
      records () {
        const dataset = this.$store.getters.dataset(this.datasetId)
        if (!dataset) return []
        const records = [].concat(dataset.records)
        records.sort((a, b) => {
          return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER)
        })
        return records.map(record => {
          return this.mapRecord(record, this.columnMap)
        })
      }
    },
    watch: {
      records: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {records: val}
        })
      },
      sponsorsAlbumId: function (val) {
        const album = this.$store.getters.album(val) || {}
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {sponsors: album.pictures}
        })
      },
      ...mapImageIdToImage('logosAlbumId', 'topLeftImageId', 'topLeftImage'),
      ...mapImageIdToImage('logosAlbumId', 'topRightImageId', 'topRightImage')
    },
    methods: {
      mapRecord (record, columnMap) {
        return Object.keys(columnMap).reduce((result, key) => {
          result[key] = record[columnMap[key]]
          return result
        }, {})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/starting-list.vue